<template>
  <b-container>
    <div class="pb-lg-5 pt-lg-5">
      <b-row>
        <div class="col-lg-3 col-md-3 col-sm-2"></div>
        <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
          <h2 class="text-center mb-3">Forgot your password?</h2>
          <p>Please enter the email address registered on your account.</p>
          <br>
          <br>
          <b-form>
            <b-form-group class="text-left" label="Email address">
              <b-form-input
                placeholder="Enter your email"
                required
                type="text"
                v-model="email">
              </b-form-input>
            </b-form-group>
            <b-button @click="sendResetRequest" class="btn btn-block bg-orange" variant="info">Reset password</b-button>
          </b-form>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'forgotPassword',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    sendResetRequest () {
      this.$store.dispatch('requestResetPassword', this.email)
        .then(response => {
          this.showMsgSuccess()
        })
        .catch(error => {
          this.showMsgFail()
        })
    },
    showMsgSuccess () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('An email has been sent to the provided email address with further instructions.', {
        okVariant: 'success'
      })
        .then(value => {
          this.$router.push({ name: 'home' })
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    showMsgFail () {
      this.boxOne = ''
      // if (error === 'Invalid login.') {
      this.$bvModal.msgBoxOk('Something went wrong. Please ensure the email is correct and try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
        // }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue